<template>
  <div class="container-370 mt-40">
    <div class="meeting-card-success">
        <p class="main-title text-center mb-10" v-if="$auth.user().type === 0">以下の内容で予約申請して良いですか？</p>
        <p class="main-title text-center mb-10" v-else>以下の内容で予約して良いですか？</p>
        <p class="sub-main-title text-center mb-20">※予約の確定ではありません。</p>
        <div class="meeting-card-success-body z-index-2 text-center w-370">
            <div class="meeting-date mb-10" v-if="meeting.time.start">
              <span v-if="$route.name === 'meetings.edit'">{{localMeeting.time.start.format('Y年 MM月 DD日')}}</span>
              <span v-else>{{meeting.time.start.format('Y年 MM月 DD日')}}</span>
              ({{meeting.time.start.day() | dayOfWeekLabel}})
            </div>
            <div class="meeting-time mb-10" v-if="meeting.time.start">
              <span v-if="$route.name === 'meetings.edit'">{{localMeeting.time.start.format('HH:mm')}}〜{{localMeeting.time.end.format('HH:mm')}}</span>
              <span v-else>{{meeting.time.start.format('HH:mm')}}〜{{meeting.time.end.format('HH:mm')}}</span>
            </div>
            <div class="meeting-type mb-20" v-if="category">
              {{category.name_kanji}}
            </div>
            
            <div class="meeting-users mb-20 mt-20">
              <p>
                {{$auth.user().name}} (患者)
              </p>
              <p v-if="meeting.pharmacy">
                {{meeting.pharmacy.pmc_name}} - 主催者
              </p>
            </div>
            <div class="meeting-content">
              {{meeting.title}}
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'

export default {
  props: {
    meeting: {type: Object, required: false},
    localMeeting: {type: Object, required: false}
  },
  computed: {
    ...mapGetters({
      meetingCategories: 'meetings/categories'
    }),
    category: function () {
      if (this.$route.name === 'meetings.edit') return this.meetingCategories.find(n => n.id === this.localMeeting.category.id)
      return this.meetingCategories.find(n => n.id === this.meeting.category)
    }
  },
  mounted() {
    if(this.meeting.time_picked) {
      this.meeting.time = this.meeting.time_picked
      this.meeting.time.start = moment(this.meeting.time_picked.start)
      this.meeting.time.end = moment(this.meeting.time_picked.end)
      this.localMeeting.time.start = moment(this.localMeeting.time.start)
      this.localMeeting.time.end = moment(this.localMeeting.time.end)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/Confirm.vue